import { render, staticRenderFns } from "./RecommendedPlans.vue?vue&type=template&id=25daa3e5&scoped=true"
import script from "./RecommendedPlans.vue?vue&type=script&lang=js"
export * from "./RecommendedPlans.vue?vue&type=script&lang=js"
import style0 from "./RecommendedPlans.vue?vue&type=style&index=0&id=25daa3e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25daa3e5",
  null
  
)

export default component.exports